<template>
    <div class='processing-wrapper' :class="[customClass, {'full-screen': fullScreen}]">
        <loading-svg :class="['blinking', loadingClass]"></loading-svg>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import LoadingSvg from '@/components/Svg/Loading.vue';

export default Vue.extend({
    components: {
        LoadingSvg
    },
    props: {
        customClass: String,
        fullScreen: {
            type: Boolean,
            default: false
        },
        loadingClass: {
            type: String,
            default: ''
        },
    }
});
</script>

<style lang="less" scoped>
.processing-wrapper{
    text-align: center;
    min-height: 40px;
    overflow: hidden;
    @media @snapeak_mobile{
        min-height: 24px;
    }
    &.full-screen{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        @media @mobile{
            height: calc(100vh - 46px);
        }
    }
}
.blinking{
    width: 40px;
    height: 40px;
    color: @theme;
    position: relative;
    padding: 8px;
    text-align: center;
    animation: 1s rotate ease-in-out infinite;
    @media @snapeak_mobile{
        width: 24px;
        height: 24px;
    }
}

@keyframes rotate{
    6.25%{
        transform: rotate(22.5deg);
    }
    12.5%{
        transform: rotate(45deg);
    }
    18.25%{
        transform: rotate(67.5deg);
    }
    25%{
        transform: rotate(90deg);
    }
    31.25%{
        transform: rotate(112.5deg);
    }
    37.5%{
        transform: rotate(135deg);
    }
    43.75%{
        transform: rotate(157.5deg);
    }
    50%{
        transform: rotate(180deg);
    }
    56.25%{
        transform: rotate(202.5deg);
    }
    62.5%{
        transform: rotate(225deg);
    }
    68.75%{
        transform: rotate(247.5deg);
    }
    75%{
        transform: rotate(270deg);
    }
    81.25%{
        transform: rotate(292.5deg);
    }
    87.5%{
        transform: rotate(315deg);
    }
    93.75%{
        transform: rotate(337.5deg);
    }
    100%{
        transform: rotate(360deg);
    }
}
</style>
